import { Injectable, signal } from "@angular/core";
import { v4 } from "uuid";
import { LogService } from "./log.service";
import { BaseService } from "./base.service";
import { NavigationService } from "./navigation.service";

@Injectable({ providedIn: "root" })
export class AppInstanceService extends BaseService {
  public updateAvailable = signal<boolean>(false);

  private channel = new BroadcastChannel("app-instance");

  private instanceID = v4();

  public isActive = true;

  constructor(
    private navigationService: NavigationService,
    logService: LogService,
  ) {
    super(logService, "AppInstanceService");
  }

  public preventMultipleAppInstances() {
    this.channel.postMessage({
      type: "new",
      instanceID: this.instanceID,
    });
    this.registerListeners();
  }

  private registerListeners() {
    this.channel.onmessage = (event) => this.handleMessages(event.data);
  }

  private async handleMessages({ type, ...data }: any) {
    if (type === "new" && this.isActive) {
      this.channel.postMessage({
        type: "redirect",
        instanceID: data.instanceID,
      });
      return;
    }
    if (type === "redirect" && data.instanceID === this.instanceID) {
      this.isActive = false;
      await this.navigationService.navigate(
        "message?content=This app is not designed for use with multiple tabs, this is done to preserve data integrity. &title=Multiple Tabs Not Allowed&subtitle=Please Close This Tab And Only Use A Singular Tab",
      );
    }
  }
}
